import { getBreadCrumbList, setTagNavListInLocalstorage, getMenuByRouter, getTagNavListFromLocalstorage, getHomeRoute, getNextRoute, routeHasExist, routeEqual, getRouteTitleHandled, GetToken, SetToken } from '@/libs/util'
import { saveErrorLogger } from '@/api/data'
import router from '@/router'
import routers from '@/router/routers'
import config from '@/config'
import { GetCurrencyLiSt } from '@/api/admin/app'

const { homeName, test } = config
const closePage = (state, route) => {
    const nextRoute = getNextRoute(state.tagNavList, route)
    state.tagNavList = state.tagNavList.filter((item) => {
        return !routeEqual(item, route)
    })
    router.push(nextRoute)
}

export default {
    state: {
        breadCrumbList: [],
        tagNavList: [],
        homeRoute: {},
        local: GetToken().local,
        errorList: [],
        hasReadErrorPage: false,
        menuData: [1, 2, 15, 6, 8, 165],
        promList: [],
        plat_list: GetToken().plat_list || [],
        all_app_list: GetToken().all_app_list || [],
        app_list: GetToken().app_list || [],
        init_func: null,
        globalCurrencyList: [],
    },
    getters: {
        menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
        errorCount: (state) => state.errorList.length
    },
    mutations: {
        setPlatList(state, plat_list) {
            if (plat_list.length > 0 && state.all_app_list.length > 0) {
                state.plat_list = plat_list.filter((el: any) => el.id == 29 || state.app_list.some((item: any) => item.platform == el.id))
                SetToken({ plat_list })
            } else {
                state.plat_list = plat_list
                SetToken({ plat_list })
            }
        },
        setAppList(state, list) {
            let filterArray = [8001, 8008, 8216, 8007, 8215, 8003, 8213, 6019, 8009, 8019]
            let all_app_list = list.filter((el: any) => !filterArray.includes(el.appid))
            state.all_app_list = all_app_list
            let app_list = all_app_list.filter((el: any) => el.appid)
            state.app_list = app_list
            SetToken({ all_app_list, app_list })
            if (state.plat_list.length > 0 && state.all_app_list.length > 0) {
                state.plat_list = state.plat_list.filter((el: any) => el.id == 29 || state.app_list.some((item: any) => item.platform == el.id))
                SetToken({ plat_list: state.plat_list })
            }
        },
        setBreadCrumb(state, route) {
            state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
        },
        setHomeRoute(state, routes) {
            state.homeRoute = getHomeRoute(routes, homeName)
        },
        setmenuData(state, routes) {
            state.menuData = routes
        },
        setTagNavList(state, list) {
            let tagList: any[] = []
            if (list) {
                tagList = [...list]
            } else tagList = getTagNavListFromLocalstorage() || []
            if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
            let homeTagIndex = tagList.findIndex((item) => item.name === homeName)
            if (homeTagIndex > 0) {
                let homeTag = tagList.splice(homeTagIndex, 1)[0]
                tagList.unshift(homeTag)
            }
            state.tagNavList = tagList
            setTagNavListInLocalstorage([...tagList])
        },
        closeTag(state, route) {
            let tag = state.tagNavList.filter((item) => routeEqual(item, route))
            route = tag[0] ? tag[0] : null
            if (!route) return
            closePage(state, route)
        },
        addTag(state, { route, type = 'unshift' }) {
            let router = getRouteTitleHandled(route)
            if (!routeHasExist(state.tagNavList, router)) {
                if (type === 'push') state.tagNavList.push(router)
                else {
                    if (router.name === homeName) state.tagNavList.unshift(router)
                    else state.tagNavList.splice(1, 0, router)
                }
                setTagNavListInLocalstorage([...state.tagNavList])
            }
        },
        setLocal(state, local) {
            SetToken({ local })
            state.local = local
        },
        addError(state, error) {
            state.errorList.push(error)
        },
        setHasReadErrorLoggerStatus(state, status = true) {
            state.hasReadErrorPage = status
        },
        setCurrencyList(state, data) {
            state.globalCurrencyList = data
        }
    },
    actions: {
        addErrorLog({ commit, rootState }, info) {
            if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
            const {
                user: { token, userId, userName }
            } = rootState
            let data = {
                ...info,
                time: Date.parse(new Date().toString()),
                token,
                userId,
                userName
            }
            saveErrorLogger(info).then(() => {
                commit('addError', data)
            })
        },
        doGetCurrencyList({ commit }) {
            GetCurrencyLiSt({status: 1}).then(res => {
                commit('setCurrencyList', res._param.data)
            });
        },
    }
}
